import { type Side } from "@design-lab/shared";
import { useArtworkForm, useArtwork } from "@design-lab/entities/artwork";
import { usePlacementPosition } from "@design-lab/widgets/artboard/model/usePlacementPosition";
import { useResponsive } from "@design-lab/shared/hooks/useResponsive";
import {
  DesignLabImageSelector,
  ImageSize,
  ImagePlacement
} from "@design-lab/widgets/design-lab-upload-artwork";

import { TabCard } from "@design-lab/shared/ui/layouts/TabCard";
import { AddToCartToolbar } from "@design-lab/features/add-to-cart";
import { PlacementControlTooltip } from "./PlacementControlTooltip";
import { SelectPrintQuality } from "./SelectPrintQuality";

export type DesignArtworkProps = {
  title: string;
  side: Side;
};

export function DesignArtwork({ side, title }: DesignArtworkProps) {
  const { lens } = useArtworkForm();
  const currentPlacementLens = lens.focus("currentPlacement");
  const { placement } = usePlacementPosition(currentPlacementLens);

  const placementLens = lens.focus(placement);
  const { isDesktop } = useResponsive();
  const { getMachineBySide } = useArtwork();
  const machine = getMachineBySide(side);

  let content;

  if (machine.state.matches("initial") || machine.state.hasTag("loading")) {
    content = (
      <>
        <DesignLabImageSelector side={side} />
      </>
    );
  } else {
    content = (
      <>
        {isDesktop ? (
          <>
            <div className="flex items-center justify-between gap-2">
              <h3 className="font-semibold">Image size</h3>
              <ImageSize lens={placementLens.focus("size")} side={side} />
            </div>

            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center">
                <h3 className="font-semibold">Image placement</h3>
                <PlacementControlTooltip isDesktop={isDesktop} />
              </div>
              <ImagePlacement />
            </div>

            <SelectPrintQuality />
          </>
        ) : (
          <SelectPrintQuality />
        )}
      </>
    );
  }

  return (
    <TabCard
      title={title}
      showNextButton={!isDesktop}
      footer={isDesktop && side === "back" && <AddToCartToolbar />}
    >
      {content}
    </TabCard>
  );
}
